/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_SaveInputs */

const vi_invoice_save = /** @type {(inputs: Invoice_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu cài đặt`)
};

/**

* @param {Invoice_SaveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_save = /** @type {((inputs?: Invoice_SaveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_SaveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_save(inputs)
});